import "../assets/css/--component-app-loader.css";

function AppLoader({ text }) {
  return (
    <div className="app-loader">
      <div className="app-loader-spinner">
        <i className="ri-restaurant-2-line"></i>
      </div>
      {text && <p className="app-loader-text">{text}</p>}
    </div>
  );
}

export default AppLoader;
